import { embeddedValue } from '@interhyp/api-values';
import { useEffect } from 'react';

export function useCheckEmbedded(): void {
  const [isEmbedded, setValue] = embeddedValue.useValue();
  useEffect(() => {
    // skip check if already checked
    if (typeof isEmbedded === 'boolean') {
      return;
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Set embedded value depending on url parameter
    setValue(urlParams.has('embedded'));
  }, [setValue, isEmbedded]);
}
